import { axiosInstance } from "./axios";
import { AxiosResponse } from "axios";
import useCustomQuery from "hooks/useCustomQuery";

const queryKeys = {
  getZipCode: (zipCode: string | number) => [
    "TerytService.getZipCode",
    zipCode,
  ],
  getCity: (cityName: string, zipCode?: string) => [
    "TerytService.getCity",
    cityName,
    zipCode,
  ],
  getStreet: (cityId: string | null, name: string) => [
    "TerytService.getStreet",
    cityId,
    name,
  ],
};

export interface IPlace {
  Id: string;
  Name: string;
  Voivodeship?: string;
  District?: string;

  VoivodeshipId?: string;
  DistrictId?: string;

  ZipCodes?: IZipCode[];
}

export interface IZipCode {
  Value: string;
  Places?: IPlace[];
}

export interface IStreet {
  Id: string;
  Name: string;
  CityId: string;
}

const getZipCode = async (zip: string): Promise<{ data: IZipCode[] }> => {
  if (!zip?.length) {
    return {
      data: [],
    } as AxiosResponse;
  }
  return await axiosInstance.get(`/Teryt/ZipCode?query=${zip}`);
};

const useGetZipCode = (zip: string) => {
  return useCustomQuery(queryKeys.getZipCode(zip), () => getZipCode(zip));
};

const getCity = async (
  cityName?: string,
  zipCode?: string
): Promise<{ data: IPlace[] }> => {
  if (!cityName?.length && !zipCode?.length) {
    return {
      data: [],
    } as AxiosResponse;
  }

  if (zipCode && cityName) {
    return await axiosInstance.get(
      `/Teryt/City?query=${cityName}&zipCode=${zipCode}`
    );
  }

  if (zipCode) {
    return await axiosInstance.get(`/Teryt/City?zipCode=${zipCode}`);
  }

  return await axiosInstance.get(`/Teryt/City?query=${cityName}`);
};

const useGetCity = (cityName?: string, zipCode?: string) => {
  return useCustomQuery(queryKeys.getCity(cityName, zipCode), () =>
    getCity(cityName, zipCode)
  );
};

const getStreet = async (
  cityId: string | null,
  name: string
): Promise<{ data: IStreet[] }> => {
  //
  if (!cityId?.length) {
    return {
      data: [],
    } as AxiosResponse;
  }

  return await axiosInstance.get(
    `/Teryt/Street?cityId=${cityId}&query=${name}`
  );
};

const useGetStreet = (cityId: string | null, name: string) => {
  return useCustomQuery(queryKeys.getStreet(cityId, name), () =>
    getStreet(cityId, name)
  );
};

export default {
  useGetZipCode,
  useGetCity,
  useGetStreet,
};
